// components/CTA.jsx
import { Link } from "react-router-dom";

export default function CTA({
  title,
  subtitle,
  buttonText,
  buttonLink,
  variant = "primary",
}) {
  const colors = {
    primary:
      "bg-[#6A0DAD] text-white hover:bg-[#5F0F99]",
    secondary:
      "border border-[#6A0DAD] text-[#6A0DAD] hover:bg-[#6A0DAD] hover:text-white",
  };

  return (
    <div className="py-20 px-6 bg-[#F3E8FF] rounded-lg text-center max-w-full mx-auto shadow-lg my-2">
      <h3 className="text-4xl font-bold mb-4 text-[#2D033B]">
        {title}
      </h3>
      <p className="text-[#5A3D73] mb-8 max-w-2xl mx-auto">
        {subtitle}
      </p>
      <Link
        to={buttonLink}
        className={`inline-block px-8 py-3 rounded-md text-lg font-semibold transition ${colors[variant]}`}
      >
        {buttonText}
      </Link>
    </div>
  );
}
